(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["indiao-price"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('indiao-price')) {
    customElements.define(
      'indiao-price',
      class extends HTMLElement {
        connectedCallback() {
          this.onVariant = (event) => {
            const detail = event.detail || {};
            const html = detail.data && detail.data.html;
            if (!html) return;
            if (detail.data.productId && String(detail.data.productId) !== this.dataset.productId) return;
            const fresh = html.querySelector('indiao-price[data-block-id="' + this.dataset.blockId + '"]');
            if (fresh) this.innerHTML = fresh.innerHTML;
          };
          document.addEventListener('variant:update', this.onVariant);
        }
        disconnectedCallback() {
          document.removeEventListener('variant:update', this.onVariant);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["indiao-size-guide"] && !Shopify.designMode) return;
  try {
    if (!window.__indSizeGuide) {
    window.__indSizeGuide = true;
    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-ind-open]');
      if (opener) {
        const dialog = document.getElementById(opener.dataset.indOpen);
        if (dialog && typeof dialog.showModal === 'function') {
          dialog.showModal();
          document.documentElement.style.overflow = 'hidden';
        }
        return;
      }
      const closer = event.target.closest('[data-ind-close]');
      let dialog = null;
      if (closer) {
        dialog = closer.closest('dialog');
      } else if (event.target.classList && event.target.classList.contains('ind-size__dialog')) {
        dialog = event.target;
      }
      if (dialog) dialog.close();
    });
    document.addEventListener(
      'close',
      (event) => {
        const el = event.target;
        if (el && el.classList && el.classList.contains('ind-size__dialog')) {
          document.documentElement.style.overflow = '';
        }
      },
      true
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["indiao-stock"] && !Shopify.designMode) return;
  try {
    if (!window.__indStockSync) {
    window.__indStockSync = true;
    document.addEventListener('variant:update', (event) => {
      const detail = event.detail || {};
      const html = detail.data && detail.data.html;
      if (!html) return;
      const incoming = html.querySelectorAll('.ind-stock');
      document.querySelectorAll('.ind-stock[data-block-id]').forEach((el) => {
        const id = el.getAttribute('data-block-id');
        let fresh = null;
        incoming.forEach((n) => {
          if (n.getAttribute('data-block-id') === id) fresh = n;
        });
        if (fresh) {
          el.innerHTML = fresh.innerHTML;
          el.hidden = false;
        } else {
          el.hidden = true;
        }
      });
    });
  }
  } catch(e) { console.error(e); }
})();

})();
